<template>
  <div :class="mode">
    <div :class='"main-"+mode' v-if="showmain">
      <slot name='main'></slot>
    </div>
    <div :class='"resize-"+mode' v-if="showmain"></div>
    <div class='athor'>
      <slot name='athor'></slot>
    </div>
  </div>
</template >

<script>
export default {
	props: {
		mode: {
			type: String,
			default: 'horizontal',
			desc: '模式:horizontal/vertical',
		},
		min: {
			type: Number,
			default: 200,
			desc: '最小',
		},
		max: {
			type: Number,
			default: 600,
			desc: '最小',
		},
		showmain: {
			type: Boolean,
			default: true,
			desc: '关闭',
		},
	},
	mounted() {
		this.dragControllerDiv()
	},
	methods: {
		dragControllerDiv() {
			if (this.mode == 'horizontal') {
				var resize = document.getElementsByClassName('resize-horizontal')[0]
				var main = document.getElementsByClassName('main-horizontal')[0]
				// 鼠标按下事件
				resize.onmousedown = (e) => {
					var startX = e.clientX
					var width = main.clientWidth
					// 鼠标拖动事件
					document.onmousemove = (e) => {
						var endX = e.clientX
						var newwidth = width + (endX - startX)
						if (newwidth < this.min) newwidth = this.min // 左边区域的最小宽度为150px
						if (newwidth > this.max) newwidth = this.max //右边区域最小宽度为150px
						main.style.width = newwidth + 'px' // 设置左侧区域的宽度
					}
					// 鼠标松开事件
					document.onmouseup = () => {
						document.onmousemove = null
						document.onmouseup = null
						resize.releaseCapture && resize.releaseCapture() //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
					}
					resize.setCapture && resize.setCapture() //该函数在属于当前线程的指定窗口里设置鼠标捕获
					return false
				}
			} else {
				var resize = document.getElementsByClassName('resize-vertical')[0]
				var main = document.getElementsByClassName('main-vertical')[0]
				// 鼠标按下事件
				resize.onmousedown = (e) => {
					var startY = e.clientY
					var height = main.clientHeight
					// 鼠标拖动事件
					document.onmousemove = (e) => {
						var endY = e.clientY
						var newheight = height + (endY - startY)
						if (newheight < this.min) newheight = this.min // 左边区域的最小宽度为150px
						if (newheight > this.max) newheight = this.max //右边区域最小宽度为150px
						main.style.height = newheight + 'px' // 设置左侧区域的宽度
					}
					// 鼠标松开事件
					document.onmouseup = () => {
						document.onmousemove = null
						document.onmouseup = null
						resize.releaseCapture && resize.releaseCapture() //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
						this.$emit('update')
					}
					resize.setCapture && resize.setCapture() //该函数在属于当前线程的指定窗口里设置鼠标捕获
					return false
				}
			}
		},
	},
}
</script>
 
<style lang="scss" scoped>
.horizontal {
	width: 100%;
	height: 100%;
	display: flex;
	overflow: hidden;
}
.vertical {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.main-horizontal {
	width: 400px;
	overflow: auto;
}
.main-vertical {
	height: 400px;
	overflow: auto;
}
.resize-horizontal {
	width: 0;
	border-left: 1px dashed gray;
	border-width: 4px;
	cursor: w-resize;
	position: relative;
}
.resize-vertical {
	height: 0;
	border-top: 1px dashed gray;
	border-width: 4px;
	cursor: n-resize;
	position: relative;
}
.athor {
	flex: 1;
	overflow: auto;
}
</style>